import React from "react";
import Header from "./Header";
import Footer from "./Footer";

// import Footer from "./Footer";

function WebsiteLayout({ children }) {
  return (
    <div className="flex flex-col  dark:bg-gray-900 dark:text-white">
      <Header/>
      <main className="">
        {children}
      </main>
      <Footer/>
    </div>
  );
}

export default WebsiteLayout;

